
<!--<div *ngFor="let l of CurrentActorMedicalFitnessInfoController">

  <div class="comon-box eh-box   pb-0" *ngIf="ShowList">
    <div class="row pl-3  margin-left-zero pr-3">
      <div class="col-md-12 add-new-cerit">
        <div class="edit-tools">
          
          <a (click)="edit_(l)" *ngIf="CanEdit === 1 " class=" nav-link-hand education-navlink"><i class="fas fa-pencil-alt"></i></a>
          <a (click)="del_(l.ActorCredentialCode)" *ngIf="CanEdit === 1 " class=" nav-link-hand education-navlink"><i class="far fa-trash-alt"></i></a>
          <a (click)="openDocContent(l.ActorDocCode)" class="nav-link-hand education-navlink">
            
             <i class="fas fa-paperclip"></i>
           
          </a>
          </div>
          <div class="row border-bottom">
             


            <div class="col-md-4">
              <div class="form-group">
                <label>Record Type</label>
                <span class="form-result">{{l.CredentialType}}</span>
              </div>
            </div>
            
            
            <div class="col-md-4">
            
              <div class="form-group">
                <label>Date of Service</label>


             
                <span class="form-result">{{l.ValidFrom | date:'MMM-dd-yyyy'}} </span>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group">
                <label>Additional Details</label>
                <span class="form-result">{{l.AdditionalDetail}}</span>
              </div>
            </div>

           
           
         
          </div>
        </div>
      </div>
  </div>
</div>-->
<div class="card-content profile-eduction " *ngIf="ShowList">
  <div class="panel-heading">
    <div class="row">
      <div class="col-12">
        <!--<h6 class="panel-title fb">Education Info</h6>-->
        <div class="table-component">
          <div class="table-responsive">
            <table class="table  profile-table">
              <thead class="profile-thead ">
                <tr>
                  <th scope="col">Record Type</th>
                  <th scope="col">Date of Service</th>
                  <th scope="col">Additional Details</th>
                  <th scope="col">Action</th>

                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let l of CurrentActorMedicalFitnessInfoController">
                  <td>{{l.CredentialType}}</td>
                  <td>{{l.ValidFrom | date:'MMM-dd-yyyy'}} </td>
                  <td>{{l.AdditionalDetail}}</td>
                  

                  <td>
                    <div class="row">
                      <a (click)="edit_(l)" class="nav-link-hand education-navlink" *ngIf="CanEdit === 1 ">
                        <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                      </a>
                      <a (click)="del_(l.ActorCredentialCode)" class="nav-link-hand education-navlink" *ngIf="CanEdit === 1 ">
                        <span class="badge">
                          <i class="far fa-trash-alt"></i>
                        </span>
                      </a>
                      <a (click)="openDocContent(l.ActorDocCode)" class="nav-link-hand education-navlink">
                        <span class="badge">
                          <!--<i class="fa fa-file grey"></i>--><i class="fas fa-paperclip"></i>
                        </span>
                      </a>
                    </div>
                  </td>
                </tr>

              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div *ngIf='IsExpand'>
  <div class="row" *ngIf="ShowList">
    <div class="col-md-12 col-xs-12 mt-2 mb-4 text-right add-but">
      <button type="button" (click)="clearData()" class="btn btn-primary btn-sm"> Add New</button>
    </div>
  </div>
  <div *ngIf='isNew && !ShowList'>
    <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">

      <div class="comon-box margin-left-zero p-0">
        <h4 class="heading-pinkbg mt-0">Add Medical Document</h4>
        <div class="row pl-3 pr-3 margin-left-zero margin-left-zero">


          <div class="form-group col-md-6 col-xs-12">
            <label for="eventInput1"><span>*</span> Record Type </label>
            <CustomDataByRequestType RequestedType="CredentialTypeByGroup" CustomType="ActorMedicalFitness" id="CurrentActorMedicalFitnessRequest.CredentialTypeCode"
                                     [(ngModel)]="CurrentActorMedicalFitnessRequest.CredentialTypeCode" name="CurrentActorMedicalFitnessRequest.CredentialTypeCode" required
                                     (keyChange)="onCredentialTypeByGroup($event)" #CredentialTypeCode="ngModel">
            </CustomDataByRequestType>
            <small class="form-text text-danger"
                   *ngIf="(!CredentialTypeCode.valid && (CredentialTypeCode.dirty || CredentialTypeCode.touched) && CredentialTypeCode.errors.required )">(Field cannot be left blank)</small>


          </div>

          <!--<div class="form-group col-md-6 col-xs-12">
    <label for="eventInput2">Certificate Number</label>
    <input type="text" class="form-control" id="CurrentActorMedicalFitnessRequest.CredentialNumber" [(ngModel)]="CurrentActorMedicalFitnessRequest.CredentialNumber" name="CurrentActorMedicalFitnessRequest.CredentialNumber" placeholder="CredentialNumber">
  </div>-->

          <div class="form-group col-md-6 col-xs-12">
            <label for="eventInput4">Date of Service</label>
            <!--<label for="eventInput4">Date of Service</label>
    <input type="date" class="form-control" id="CurrentActorMedicalFitnessRequest.ValidFrom" [(ngModel)]="CurrentActorMedicalFitnessRequest.ValidFrom" name="CurrentActorMedicalFitnessRequest.ValidFrom" placeholder="ValidFrom">-->
            <!--<div *ngIf="CanAdjustgetTimezoneOffset">
      <input [owlDateTimeTrigger]="ValidFrom" class="form-control" [owlDateTime]="ValidFrom"
             [max]="MaxDateV"
             id="CurrentActorMedicalFitnessRequest.ValidFrom"
             placeholder="Date of Service"
             [(ngModel)]="CurrentActorMedicalFitnessRequest.ValidFrom"
             name="CurrentActorMedicalFitnessRequest.ValidFrom">
      <owl-date-time [pickerType]="'calendar'" #ValidFrom></owl-date-time>
    </div>-->
            <div class="date-form">
              <input class="form-control" placeholder="Date of Service" [minDate]="minDate" [maxDate]="maxDate"
                     name="dp1" [(ngModel)]="ValidFrom" ngbDatepicker #d1="ngbDatepicker">

              <a (click)="d1.toggle()" class=" nav-link-hand">
                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

              </a>


            </div>

          </div>

          <!--<div class="form-group col-md-6 col-xs-12">
    <label for="eventInput5">Expiring Date</label>
    <input type="date" class="form-control" id="CurrentActorMedicalFitnessRequest.ValidTo" [(ngModel)]="CurrentActorMedicalFitnessRequest.ValidTo" name="CurrentActorMedicalFitnessRequest.ValidTo" placeholder="ValidTo">

  </div>-->
          <!--<div class="form-group col-md-6 col-xs-12">
    <label for="eventInput5">Issuing Authority</label>

    <CodeTypeValue CodeType="CTIAT" id="CurrentActorMedicalFitnessRequest.IssuingAuthority"
                   [(ngModel)]="CurrentActorMedicalFitnessRequest.IssuingAuthority" name="CurrentActorMedicalFitnessRequest.IssuingAuthority"></CodeTypeValue>
  </div>-->

          <div class="form-group col-md-6 col-xs-12">
            <label for="eventInput5">Additional Details</label>
            <input type="text" class="form-control" id="CurrentActorMedicalFitnessRequest.AdditionalDetails"
                   [(ngModel)]="CurrentActorMedicalFitnessRequest.AdditionalDetails" #AdditionalDetails="ngModel" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                   name="CurrentActorMedicalFitnessRequest.AdditionalDetails" placeholder="Additional Details" maxlength="100">
            <small class="form-text text-danger"
                   *ngIf="(!AdditionalDetails.valid && AdditionalDetails.errors.pattern)">(special characters are not allowed)</small>
          </div>
          <!--<div class="form-group col-md-6 col-xs-12">
    <label for="eventInput5">Remarks</label>
    <input type="text" class="form-control" id="CurrentActorMedicalFitnessRequest.Remarks"
           [(ngModel)]="CurrentActorMedicalFitnessRequest.Remarks" name="CurrentActorMedicalFitnessRequest.Remarks" placeholder="Remarks">
  </div>-->
          <!--<div class="card-footer pink-bg text-right" *ngIf="CanEdit === 1 ">
    <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime">Save</button>

  </div>-->

          <br /><br /><br />  <br /><br /><br />  <br /><br /><br /><br /><br /><br /><br /><br /><br /><br />

        </div>
      </div>
      <div class="row" *ngIf="CanEdit === 1 ">
        <div class="card-footer text-right col-12">
          <button (click)="CancelNewOperation()" *ngIf='!isRequesting' class="btn actions-btn-prime nav-link-hand button-Schedule actions-btn-prime3">Cancel</button>
          <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime nav-link-hand">Save</button>

        </div>
      </div>
      






    </form>
  </div>
  <div *ngIf='isEdit && !ShowList'>
    <form class="form" novalidate="" (ngSubmit)="onEditSubmit()" #f="ngForm">

      <div class="comon-box p-0 margin-left-zero">
        <h4 class="heading-pinkbg mt-0">Update Medical Fitness</h4>
        <div class="row pl-3 pr-3 margin-left-zero">


          <div class="form-group col-md-6 col-xs-12">
            <label for="eventInput1"><span>*</span> Record Type </label>
            <CustomDataByRequestType RequestedType="CredentialTypeByGroup" CustomType="ActorMedicalFitness" id="CurrentActorEditMedicalFitnessRequest.CredentialTypeCode"
                                     [(ngModel)]="CurrentActorEditMedicalFitnessRequest.CredentialTypeCode" name="CurrentActorEditMedicalFitnessRequest.CredentialTypeCode" required
                                     (keyChange)="onCredentialTypeEditByGroup($event)" #CredentialTypeCode="ngModel" >
            </CustomDataByRequestType>
            <small class="form-text text-danger"
                   *ngIf="(!CredentialTypeCode.valid && (CredentialTypeCode.dirty || CredentialTypeCode.touched) && CredentialTypeCode.errors.required )">(Field cannot be left blank)</small>

          </div>

          <!--<div class="form-group col-md-6 col-xs-12">
        <label for="eventInput2">Certificate Number</label>
        <input type="text" class="form-control" id="CurrentActorEditMedicalFitnessRequest.CredentialNumber"
               [(ngModel)]="CurrentActorEditMedicalFitnessRequest.CredentialNumber" name="CurrentActorEditMedicalFitnessRequest.CredentialNumber" placeholder="CredentialNumber">
      </div>-->

          <div class="form-group col-md-6 col-xs-12">
            <label for="eventInput4">Date of Service</label>
            <!--<input #myDatePicker type="date" class="form-control"
  value='{{ CurrentActorEditMedicalFitnessRequest.ValidFrom | date:"yyyy-MM-dd" }}'
  (input)="onInputValidFrom(myDatePicker.value)"
  placeholder="Issue Date" />-->
            <!--<div *ngIf="CanAdjustgetTimezoneOffset">
    <input [owlDateTimeTrigger]="ValidFrom" class="form-control" [owlDateTime]="ValidFrom"
           [max]="MaxDateV"
           id="CurrentActorEditMedicalFitnessRequest.ValidFrom"
           placeholder="Date of Service"
           [(ngModel)]="CurrentActorEditMedicalFitnessRequest.ValidFrom"
           name="CurrentActorEditMedicalFitnessRequest.ValidFrom">
    <owl-date-time [pickerType]="'calendar'" #ValidFrom></owl-date-time>
  </div>-->
            <div class="date-form">
              <input class="form-control" placeholder="Date of Service" [minDate]="minDate" [maxDate]="maxDate"
                     name="dp1" [(ngModel)]="ValidFrom" ngbDatepicker #d1="ngbDatepicker">
            
              <a (click)="d1.toggle()" class=" nav-link-hand">
                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

              </a>

              </div>
              <!--<input type="date" class="form-control" id="CurrentActorEditMedicalFitnessRequest.ValidFrom"
    [(ngModel)]="CurrentActorEditMedicalFitnessRequest.ValidFrom" name="CurrentActorEditMedicalFitnessRequest.ValidFrom" placeholder="ValidFrom">-->
            </div>

            <!--<div class="form-group col-md-6 col-xs-12">
    <label for="eventInput5">Expiring Date</label>
    <input #myDatePicker1 type="date" class="form-control"
           value='{{ CurrentActorEditMedicalFitnessRequest.ValidTo | date:"yyyy-MM-dd" }}'
           (input)="onInputValidTo(myDatePicker1.value)"
           placeholder="Expiring Date" />
  </div>-->
            <!--<div class="form-group col-md-6 col-xs-12">
    <label for="eventInput5">Issuing Authority</label>

    <CodeTypeValue CodeType="CTIAT" id="CurrentActorEditMedicalFitnessRequest.IssuingAuthority"
                   [(ngModel)]="CurrentActorEditMedicalFitnessRequest.IssuingAuthority" name="CurrentActorEditMedicalFitnessRequest.IssuingAuthority"
      SelectedValue="{{CurrentActorEditMedicalFitnessRequest.IssuingAuthority}}"></CodeTypeValue>
  </div>-->

          <div class="form-group col-md-6 col-xs-12">
            <label for="eventInput5">Additional Details</label>
            
            <input type="text" class="form-control" id="CurrentActorEditMedicalFitnessRequest.AdditionalDetails"
                   [(ngModel)]="CurrentActorEditMedicalFitnessRequest.AdditionalDetails" #AdditionalDetails="ngModel" pattern="^[\sa-zA-Z0-9,._\-?]*$"
                   name="CurrentActorEditMedicalFitnessRequest.AdditionalDetails" placeholder="Additional Details" maxlength="100">
            <small class="form-text text-danger"
                   *ngIf="(!AdditionalDetails.valid && AdditionalDetails.errors.pattern)">(special characters are not allowed)</small>
          </div>
            <!--<div class="form-group col-md-6 col-xs-12">
    <label for="eventInput5">Remarks</label>
    <input type="text" class="form-control" id="CurrentActorEditMedicalFitnessRequest.Remarks"
           [(ngModel)]="CurrentActorEditMedicalFitnessRequest.Remarks" name="CurrentActorEditMedicalFitnessRequest.Remarks" placeholder="Remarks">
  </div>-->
            <!--<div class="card-footer pink-bg text-right" *ngIf="CanEdit === 1 ">
    <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime">Update</button>

  </div>-->

            <br /><br /><br />  <br /><br /><br />  <br /><br /><br /><br /><br /><br /><br /><br /><br /><br />
          </div>


      </div>

      <div class="row" *ngIf="CanEdit === 1 ">
        <div class="card-footer text-right col-12">
          <button (click)="CancelUpdateOperation()" *ngIf='!isRequesting' class="btn button-Schedule actions-btn-prime nav-link-hand actions-btn-prime3">Cancel</button>
          <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn actions-btn-prime nav-link-hand">Update</button>

        </div>
      </div>





    </form>
  </div>
</div>


<!--<div class="row">
  <div class="form-group col-md-12 col-xs-12 mt-5"><a href="#finish" role="menuitem" class="btn-blue-main">Save</a></div>
</div>-->
